import cn from 'classnames';
import dayjs from 'dayjs';
import { FC } from 'react';
import { IoWarningOutline } from 'react-icons/io5';
import { Text } from '../../../../../../../components/text/text';
import { useManagerStore } from '../../../../../../../store/use-manager-store';
import { getShiftStatus, ShiftCellType } from '../shifts-helpers';
import s from './shifts-grid-weekly.module.css';

const timeFormat = 'HH:mm';

export const ShiftsGridWeekly: FC<ShiftCellType> = (props) => {
  const { employee, date, className, onClick } = props;
  const { hasAccess } = useManagerStore();
  const isAllowed = hasAccess('staff', ['write']);

  const shifts = employee?.shifts || [];

  const shift = shifts?.find((shift) => {
    const startTime = dayjs(shift.start_time);
    const currentDate = dayjs(date);

    return startTime.isSame(currentDate, 'day');
  });
  const status = props.status || getShiftStatus(shift);

  if (!status) return null;

  return (
    <div
      className={cn(s.feature, s[status], className, isAllowed && s.clickable)}
      onClick={isAllowed ? () => onClick?.(shift ? [shift] : [], employee, date) : undefined}
    >
      {shift && (
        <div className={s.time}>
          {shift.start_time && <Text>{dayjs(shift.start_time).format(timeFormat)}</Text>}
          &nbsp;-&nbsp;
          {shift.end_time && <Text>{dayjs(shift.end_time).format(timeFormat)}</Text>}
        </div>
      )}
      {shift?.checkin && status !== 'planned' && (
        <div className={s.time}>
          {shift.checkin.start_time && (
            <Text className={s[status.split('-')?.[0]]}>
              {dayjs(shift.checkin.start_time).format(timeFormat)}
            </Text>
          )}
          &nbsp;-&nbsp;
          {shift.checkin.end_time && (
            <Text className={s[status.split('-')?.[1]]}>
              {dayjs(shift.checkin.end_time).format(timeFormat)}
            </Text>
          )}
        </div>
      )}
      {status === 'absent' && <IoWarningOutline color="#FF6262" />}
    </div>
  );
};
